import { render, staticRenderFns } from "./DiscussionForm.vue?vue&type=template&id=668c7f8e&"
import script from "./DiscussionForm.vue?vue&type=script&lang=js&"
export * from "./DiscussionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports